import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { NewsletterContext } from "../context/NewsletterContext";
import { useContext } from "react";

export const EmptyInbox = () => {
  const { config } = useContext(NewsletterContext);

  // Add this for debugging
  console.log("Current config:", config);

  return (
    <div className="flex flex-col gap-2">
      <Card className="shadow-md p-8 text-center bg-gradient-to-r from-indigo-50 to-pink-50">
        <CardContent className="flex flex-col items-center p-6">
          <div className="text-5xl mb-6">📭</div>
          <h3 className="text-2xl font-semibold mb-3">Your inbox is empty</h3>
          {config.topics?.length === 0 ? <NoConfig /> : <NoEmails />}
        </CardContent>
      </Card>
    </div>
  );
};

export const NoConfig = () => {
  const navigate = useNavigate();

  return (
    <div className="mb-8 p-5 bg-white border-2 border-black rounded-lg shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] -rotate-1">
      <p className="text-md">
        Not because it's broken, but because you haven't set up your personal
        newsletter yet.
        <span className="bg-yellow-200 px-1 mx-1 font-medium">
          Three steps. Takes two minutes.
        </span>
      </p>
      <button
        onClick={() => navigate("/dashboard/newsletter/setup")}
        className="mt-4 w-full py-4 bg-black text-white text-md font-bold tracking-wide rounded-lg
                border-2 border-black"
      >
        <div className="flex items-center justify-center">
          CREATE YOUR PERSONAL AI NEWSLETTER
          <ArrowRight className="ml-2 w-5 h-5" />
        </div>
      </button>
    </div>
  );
};

export const NoEmails = () => {
  const { config } = useContext(NewsletterContext);
  const getNextDropDate = () => {
    // First check if we have a frequency set
    if (!config?.frequency) {
      return "Please set your preferred schedule";
    }

    const today = new Date();
    console.log("frequency", config.frequency);
    console.log("preferredDay", config.preferredDay);
    console.log("today", today);

    // Handle daily case
    if (config.frequency === "daily") {
      const nextDate = new Date(today);
      nextDate.setDate(today.getDate() + 1);
      return nextDate.toLocaleDateString("en-US", {
        weekday: "long",
        day: "numeric",
        month: "long",
      });
    }

    // Handle weekly case
    if (config.frequency === "weekly") {
      if (!config.preferredDay) {
        return "Please select your preferred day for weekly updates";
      }

      const targetDay = config.preferredDay.toLowerCase();
      const daysOfWeek = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
      ];
      const targetDayNum = daysOfWeek.indexOf(targetDay);
      const nextDate = new Date(today);

      let daysUntilNext = targetDayNum - today.getDay();
      if (daysUntilNext <= 0) {
        daysUntilNext += 7;
      }
      nextDate.setDate(today.getDate() + daysUntilNext);

      return nextDate.toLocaleDateString("en-US", {
        weekday: "long",
        day: "numeric",
        month: "long",
      });
    }

    return "Please set up your preferred schedule first";
  };

  return (
    <div className="mb-8 p-5 bg-white border-2 border-black rounded-lg shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] -rotate-1">
      <p className="text-md">
        {config?.frequency ? (
          <>
            Don't worry, you'll get AI updates on your email soon.
            <span className="bg-yellow-200 px-1 mx-1 font-medium">
              Next drop: {getNextDropDate()}
            </span>
          </>
        ) : (
          <>
            Please set up your preferred schedule first.
            <span className="bg-yellow-200 px-1 mx-1 font-medium">
              {getNextDropDate()}
            </span>
          </>
        )}
      </p>
    </div>
  );
};
